module.exports = __webpack_public_path__ + "static/media/insights-card-bg.13064ca0.png";